import { reportClientError } from '@/lib/bugsnag';

export const FORM_SUBMIT_TIMEOUT_MS = 10_000;

export const isFormSubmitTimeoutError = (error: unknown): boolean =>
  error instanceof DOMException && error.name === 'TimeoutError';

export const logSeatBookingSubmitFailure = (
  error: unknown,
  context: Record<string, unknown>
): void => {
  const reportableError =
    error instanceof Error ? error : new Error('Seat booking submit failed');

  void reportClientError(reportableError, {
    metadata: { seatBooking: context },
  });
};
